import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import gql from 'graphql-tag';

export const SEARCH_CHAT_AGENTS = gql`
  query ($criteria: SearchChatAgentsCriteria!) {
    chatAgents(criteria: $criteria) {
      id
      tenantId
      externalId
      name
      phoneNumberId
      config
      __typename
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ChatAgentsService {
  constructor(
    private route: ActivatedRoute,
    private apollo: Apollo,
  ) {}

  searchChatAgents(): Observable<any[]> {
    return this.apollo
      .query({
        query: SEARCH_CHAT_AGENTS,
        variables: {
          criteria: {
            filters: {
              tenantId: this.route.snapshot.queryParams['tenant'],
            },
          },
        },
      })
      .pipe(map((res: any) => res.data.chatAgents));
  }
}